import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import { FlaskConical } from "lucide-react";
import QLDashboard from "@/components/quantlab/QLDashboard";
import QLMarketData from "@/components/quantlab/QLMarketData";
import QLOptionChain from "@/components/quantlab/QLOptionChain";
import QLImport from "@/components/quantlab/QLImport";
import QLQuality from "@/components/quantlab/QLQuality";
import QLInstruments from "@/components/quantlab/QLInstruments";

const TABS = [
  { id: "dashboard", label: "Dashboard" },
  { id: "market-data", label: "Market Data" },
  { id: "option-chain", label: "Option Chain" },
  { id: "import", label: "Import" },
  { id: "quality", label: "Data Quality" },
  { id: "instruments", label: "Instruments" },
];
const FUTURE = ["Volatility", "Regimes", "Option Behaviour", "Event Studies", "Backtesting", "Edge Finder", "Index Rotation"];

export default function QuantLab() {
  const { user, loading: authLoading } = useAuth();
  const nav = useNavigate();
  const [tab, setTab] = useState("dashboard");

  useEffect(() => {
    if (!authLoading && !user) nav("/login");
    else if (!authLoading && user && !user.is_admin) nav("/dashboard");
  }, [authLoading, user, nav]);
  if (authLoading || !user?.is_admin) return null;

  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar variant="dashboard" />
      <main className="max-w-[1400px] mx-auto px-4 md:px-6 py-6 space-y-5" data-testid="quantlab-page">
        <div className="flex items-center gap-3">
          <FlaskConical className="h-6 w-6 text-[#22C55E]" />
          <div>
            <h1 className="font-heading text-2xl font-black uppercase tracking-tight">Index Options Lab</h1>
            <p className="text-xs text-zinc-500 font-mono">Quantitative research · NIFTY / BANKNIFTY / SENSEX · real data only — no fabricated results</p>
          </div>
        </div>

        <div className="flex flex-wrap gap-1 border-b border-zinc-800 pb-px" data-testid="quantlab-nav">
          {TABS.map((t) => (
            <button key={t.id} onClick={() => setTab(t.id)}
                    className={`px-4 py-2 text-[11px] uppercase tracking-widest font-mono transition-colors border-b-2 ${tab === t.id ? "border-[#22C55E] text-white" : "border-transparent text-zinc-500 hover:text-zinc-300"}`}
                    data-testid={`quantlab-tab-${t.id}`}>
              {t.label}
            </button>
          ))}
          {FUTURE.map((f) => (
            <span key={f} className="px-3 py-2 text-[11px] uppercase tracking-widest font-mono text-zinc-700 cursor-not-allowed" title="Coming in a later phase">
              {f} <span className="text-[8px] border border-zinc-800 px-1 ml-0.5">P2+</span>
            </span>
          ))}
        </div>

        {tab === "dashboard" && <QLDashboard />}
        {tab === "market-data" && <QLMarketData />}
        {tab === "option-chain" && <QLOptionChain />}
        {tab === "import" && <QLImport />}
        {tab === "quality" && <QLQuality />}
        {tab === "instruments" && <QLInstruments />}
      </main>
    </div>
  );
}
